import { useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { field, Field, Panel } from "@/components/admin/shared";

const EMPTY = { name: "", rating: 5, comment: "", review_date: "", featured: true };

export const GoogleReviewForm = ({ onAdded }) => {
  const [f, setF] = useState(EMPTY);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/reviews", f); toast.success("Reseña agregada"); setF(EMPTY); onAdded(); } catch (err) { toast.error(errorText(err)); }
  };
  return (
    <Panel title="Agregar reseña de Google">
      <p className="mb-4 text-sm text-mute">Copia aquí las reseñas que tus clientes dejaron en Google. Las marcadas como destacadas aparecen en la página de inicio.</p>
      <form onSubmit={submit} className="space-y-3" data-testid="google-review-form">
        <Field id="greview-name" label="Nombre del cliente" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
        <label className="block text-xs uppercase tracking-wider text-mute">Estrellas
          <select className={`${field} mt-1`} value={f.rating} onChange={(e) => setF({ ...f, rating: Number(e.target.value) })} data-testid="greview-rating">
            {[5, 4, 3, 2, 1].map((n) => <option key={n} value={n}>{n} estrellas</option>)}
          </select>
        </label>
        <label className="block text-xs uppercase tracking-wider text-mute">Comentario
          <textarea rows={4} required className={`${field} mt-1 normal-case tracking-normal`} value={f.comment} onChange={(e) => setF({ ...f, comment: e.target.value })} data-testid="greview-comment" />
        </label>
        <Field id="greview-date" label="Fecha (opcional)" placeholder="Ej. octubre 2026" value={f.review_date} onChange={(e) => setF({ ...f, review_date: e.target.value })} />
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={f.featured} onChange={(e) => setF({ ...f, featured: e.target.checked })} data-testid="greview-featured" /> Destacar en inicio</label>
        <button className="btn-gold" data-testid="greview-submit-btn"><Plus size={16} /> Agregar reseña</button>
      </form>
    </Panel>
  );
};
